import React from 'react';
// import { faqData } from '../Sundance/pages/assets/faqStrings';

import { IFAQDataDoc_v2_WithSUB } from "../../App_v01_Interfaces";

interface FAQConfigProps{
  faqDataDocument: IFAQDataDoc_v2_WithSUB;
}

export const FAQ_Component_MASTER_v02_WithSUB: React.FC<FAQConfigProps> = ({faqDataDocument}) => {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center">
        <i className="bi bi-question-circle-fill me-2"></i>{faqDataDocument.title}
      </h2>

      <div className="my-accordion accordion" id="faqAccordion">
        {faqDataDocument.items.map((section, index) => {
          const sectionId = `collapse-${index}`;
          const headingId = `heading-${index}`;
          const isFirst = index === 0;

          return (
            <div className="my-accordion-item" key={index}>
              <h2 className="accordion-header" id={headingId}>
                <button
                  className={`accordion-button faq-header-large ${!isFirst ? 'collapsed' : ''}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${sectionId}`}
                  aria-expanded={isFirst}
                  aria-controls={sectionId}
                  >
                  <i className={`bi ${section.icon} me-2`}></i>
                  {section.category}
                </button>
              </h2>
              <div
                id={sectionId}
                className={`accordion-collapse collapse ${isFirst ? 'show' : ''}`}
                aria-labelledby={headingId}
                data-bs-parent="#faqAccordion"
              >
                                
                <div className="accordion-body">
                  <ul className="ps-3">
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="mb-2">
                        {item.question && <strong>{item.question}</strong>}
                        <br />
                        {item.answer}
                      </li>
                    ))}
                  </ul>
                </div> 
                
                
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ_Component_MASTER_v02_WithSUB;
